import React, { useState, useEffect } from 'react';
import { documentTemplatesAPI } from '../../services/api';

// Pick a document template and generate a merged PDF for this project. The
// backend fills the template with the project's variables, renders it to PDF,
// and files it as a Document — so on success we just refresh the list.
const GenerateDocument = ({ projectId, onGenerated }) => {
    const [templates, setTemplates] = useState([]);
    const [selectedId, setSelectedId] = useState('');
    const [generating, setGenerating] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        let cancelled = false;
        documentTemplatesAPI.getAll()
            .then(({ data }) => {
                if (cancelled) return;
                setTemplates(data);
                if (data.length > 0) setSelectedId(String(data[0].id));
            })
            .catch(err => {
                if (cancelled) return;
                console.error('Failed to load document templates:', err);
                setError('Could not load templates');
            });
        return () => { cancelled = true; };
    }, []);

    const handleGenerate = async () => {
        if (!selectedId) return;
        setGenerating(true);
        setError('');
        try {
            await documentTemplatesAPI.generate(selectedId, { projectId });
            if (onGenerated) onGenerated();
        } catch (err) {
            console.error('Failed to generate document:', err);
            setError(err.response?.data?.message || 'Failed to generate document');
        } finally {
            setGenerating(false);
        }
    };

    // Nothing to offer until an admin has authored at least one template.
    if (templates.length === 0 && !error) return null;

    return (
        <div className="doc-upload-filtered">
            <div className="doc-upload-controls">
                <select
                    value={selectedId}
                    onChange={(e) => setSelectedId(e.target.value)}
                    className="doc-type-select"
                    disabled={generating || templates.length === 0}
                >
                    {templates.map(t => (
                        <option key={t.id} value={t.id}>{t.name}</option>
                    ))}
                </select>
                <button
                    onClick={handleGenerate}
                    disabled={!selectedId || generating}
                    className="doc-upload-btn"
                >
                    {generating ? 'Generating…' : 'Generate Document'}
                </button>
            </div>
            {error && <div className="doc-error">{error}</div>}
        </div>
    );
};

export default GenerateDocument;
